import { QuestionDisplayTypeEnum } from "@/utils/enum/QuestionDisplayTypeEnum";
import type { IQuestion } from "@/types/entities/IQuestion";
import { QuestionOptionTypeEnum } from "@/utils/enum/QuestionOptionTypeEnum";
import { QuestionInputTypeEnum } from "@/utils/enum/QuestionInputTypeEnum";
import type { ICredit } from "@/types/entities/ICoursePreview";

export function useCourse() {
  const isQuestionMCQ = (question: IQuestion): boolean =>
    question.display_type === QuestionDisplayTypeEnum.default &&
    !question.is_free_text;
  const isQuestionOERQ = (question: IQuestion): boolean =>
    question.display_type === QuestionDisplayTypeEnum.default &&
    question.is_free_text;
  const isQuestionTable = (question: IQuestion): boolean =>
    question.display_type === QuestionDisplayTypeEnum.table;
  const isQuestionSelectState = (question: IQuestion): boolean =>
    isQuestionOERQ(question) &&
    question.input_type === QuestionInputTypeEnum.select &&
    question.option_type === QuestionOptionTypeEnum.states;

  const sortCredits = (credits: ICredit[]): typeof credits => {
    if (!credits?.length) {
      return credits;
    }
    return [...credits].sort((a, b) =>
      a.name === "Other" ? 1 : b.name === "Other" ? -1 : 0
    );
  };

  return {
    isQuestionMCQ,
    isQuestionOERQ,
    isQuestionTable,
    isQuestionSelectState,
    sortCredits,
  };
}
